<template>
    <div class="sidebar" ref="sidebar">
        <div v-if="$parent.$parent.showPOProjects">
            <button type="button" class="back-btn" @click="$parent.$parent.goTo('matchmaker-po')">
                <i class="fa fa-chevron-left menu-icon"></i>Back to Results
            </button>
        </div>
        <ul class="nav nav-tabs" v-if="sidebarNavigation">
            <li class="nav-item">
                <a class="nav-link nav-link-list" href @click.prevent="changeView()" :class="{'active': $route.name === 'list'}" rel="noopener">
                    <i class="nav-icon fas fa-list fa-2x"></i>
                    <span class="link-text">List</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link  nav-link-charts" href @click.prevent="changeView('charts')" :class="{'active': $route.name === 'charts'}" rel="noopener">
                    <i class="far fa-chart-bar fa-2x"></i>
                    <span class="link-text">Charts</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link nav-link-map" href @click.prevent="changeView('map')" :class="{'active': $route.name === 'map'}" rel="noopener">
                    <i class="fa fa-map-marker-alt fa-2x"></i>
                    <span class="link-text">Map</span>
                </a>
            </li>
        </ul>
        <div v-if="facetError" class="error-message">{{facetErrorMsg}}</div>
        <div v-if="facetLoader || loadingLookupData" class="loading"><span class="loader">Loading...</span></div>
        <div id="facets" v-if="facetData">
            <h2 class="facets-header fh-small"><b-link class="collapsed" v-b-toggle.faceted-items rel="noopener">
                <i class="fas fa-filter nav-icon-filter"></i>Filters<span class="on"></span><span class="off"></span></b-link>
            </h2>
            <div>
                <!-- <h2 class="facets-header fh-full">Refine <span v-if="$route.name !== 'publications'">Projects</span>  By</h2> -->
                <h2 class="facets-header fh-full">Filters</h2>
            </div>
            <b-collapse :visible="breakpoints.gt.lg" class="facets-scroll collapse" ref="facetsScroll" id="faceted-items">
                <!-- <div v-if="$route.name === 'publications'">
                    <ul v-if="publicationsFacetData && publicationsFacetData.facets  && publicationsFacetData.facets[0].values && publicationsFacetData.facets[0].values.length > 0">
                        <template v-for="(facet, facetIndex) in publicationsFacetData.facets">
                            <li  :key="facet.name" v-if="facet.values.length > 0">
                                <button
                                    class="collapse-button collapse-facet collapsed" type="button"
                                    data-toggle="collapse"
                                    :data-target="'#collapse-pub-' + index + '-' + facetIndex"
                                    :aria-expanded="false"
                                    :aria-controls="'#collapse-pub-' + index + '-' + facetIndex"
                                >
										<i class="fas fa-chevron-right arrow-right collapse-icon"></i>
                                        {{facet.display}}
                                        <button class="btn fac-clear" v-if="facetCriteria && facetCriteria[facet.name].length > 0" @click.prevent="clearSelections(facet.name, $event)">CLEAR</button>
                                </button>

                                <div class="collapse" :id="'collapse-pub-' + index + '-' + facetIndex">
                                    <ul v-if="facet.values && facetCriteria">
                                        <li v-for="value in returnFirstLevelFacets(facet.values)" :key="facet.name + '-' + value.display">

                                            <div class="custom-checkbox form-check form-check-inline mt-1 ">
                                                <input :name="facet.name + '-' + value.display" :id="facet.name + '-' + value.display" type="checkbox" v-model="facetCriteria[facet.name]" class="form-check-input" :value="value.value" @click="checkCheck(facet, value)" :indeterminate="isIndeterminate(facet, value)">
                                                <label :for="facet.name + '-' + value.display" class="form-check-label">
                                                    <span class="label-text">{{value.display}}</span>
                                                    <span class="label-count">({{value.count | addCommas}})</span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>

                <div v-if="$route.name === 'publications'">
                    <h2 class="facets-header fh-full">Project Filters</h2>
                </div> -->
                <div>
                    <ul>
                        <template  v-if="facetData.facets">
                            <li v-if="facetCriteria && facetCriteria.is_active_projects !== undefined">
                                <div class="custom-checkbox form-check form-check-inline mt-1 ms-2 is-active">
                                    <input name="active_projects" id="active_projects" type="checkbox" v-model="facetCriteria['is_active_projects']" class="form-check-input" :disabled="searchMeta && searchMeta.total <= 0" value="true" @click="changeSearchCriteria()">
                                    <label for="active_projects" class="form-check-label">
                                        <span class="label-text">Active Projects</span>
                                    </label>
                                </div>
                            </li>
                            <template v-for="(facet, facetIndex) in facetData.facets">
                                <li v-if="facet.values && facet.values.length > 0" :key="facet.name">
                                    <b-button variant="link"
                                        v-b-toggle="'collapse-' + index + '-' + facetIndex"
                                        :aria-expanded="((facetCriteria && facetCriteria[facet.name].length > 0)) ? true : false"
                                        :aria-controls="'#collapse-' + index + '-' + facetIndex"
                                    >
                                            <i class="fas fa-angle-down"></i>
                                            {{facet.display}}
                                            <button class="btn fac-clear" v-if="facetCriteria && facetCriteria[facet.name].length > 0" @click.prevent="clearSelections(facet.name, $event)">CLEAR</button>
                                    </b-button>

                                    <b-collapse :id="'collapse-' + index + '-' + facetIndex" :visible="(facetCriteria && facetCriteria[facet.name] && facetCriteria[facet.name].length > 0)">
                                        <ul v-if="facet.values && facetCriteria" class="ms-4 ps-1">
                                            <li v-for="value in returnFirstLevelFacets(facet.values)" :key="facet.name + '-' + value.display">
                                                <div class="custom-checkbox form-check form-check-inline mt-1 ">
                                                    <input :name="facet.name + '-' + value.display" :id="facet.name + '-' + value.display" type="checkbox" v-model="facetCriteria[facet.name]" class="form-check-input" :value="value.value" @click="checkCheck(facet, value)" :indeterminate.prop="isIndeterminate(facet, value)">
                                                    <label :for="facet.name + '-' + value.display" class="form-check-label">
                                                        <span class="label-text">{{value.display}}</span>
                                                        <span class="label-count" v-if="!omitCount">({{filters.addCommas(value.count)}})</span>

                                                        <b-link
                                                            v-if="value.children_values && value.children_values.length !== 0"
                                                            class="ms-2"
                                                            v-b-toggle="'collapse-' + index + '-' + facetIndex + value.value + 'children'"
                                                            :aria-expanded="facetIndex == 0 && index == 0 ? true : false"
                                                            :aria-controls="'#collapse-' + index + '-' + facetIndex + value.value + 'children'"
                                                            rel="noopener"
                                                        >
                                                            <i class="fas fa-angle-down"></i>
                                                            <span class="sr-only">expand</span>
                                                        </b-link>

                                                    </label>
                                                </div>

                                                <b-collapse
                                                    v-if="value.children_values && value.children_values.length !== 0"
                                                    :id="'collapse-' + index + '-' + facetIndex + value.value + 'children'"
                                                >
                                                    <ul>
                                                        <li v-for="child in returnSecondLevelFacets(facet.values, value.value)" :key="facet.name + '-' + child.display">

                                                            <div class="custom-checkbox form-check form-check-inline mt-1 ">
                                                                <input :name="facet.name + '-' + child.display" :id="facet.name + '-' + child.display" type="checkbox" v-model="facetCriteria[facet.name]" class="form-check-input" :value="child.value" @click="checkCheck(facet, child)">
                                                                <label :for="facet.name + '-' + child.display" class="form-check-label">
                                                                    <span class="label-text">{{child.display}}</span>
                                                                    <span class="label-count" v-if="!omitCount">({{filters.addCommas(child.count)}})</span>
                                                                </label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </b-collapse>
                                            </li>
                                        </ul>
                                    </b-collapse>
                                </li>
                            </template>
                        </template>
                        <li v-if="$route.name.indexOf('matchmaker') == -1">
                            <b-button v-b-toggle="'collapse-pub-disc'" variant="link">
                                <i class="fas fa-angle-down"></i> Disclaimer
                            </b-button>
                            <b-collapse  id="collapse-pub-disc">
                                <div class="px-3 pt-1 small ">Publications are associated with projects, but cannot be identified with any particular year of the project or fiscal year of funding. This is due to the continuous and cumulative nature of knowledge generation across the life of a project and the sometimes long and variable publishing timeline. Similarly, for multi-component projects, publications are associated with the parent core project and not with individual sub-projects.</div>
                            </b-collapse>
                        </li>
                    </ul>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import breakpoints from '@/shared/breakpoints.utils.js';
    import {app} from '@/main';

    export default {
        name: 'BaseFacets',
        props: {
            rawFacetData: {
                required: true
            },
            facetCriteria: {
                required: true
            },
            sidebarNavigation: {
                required: true
            },
            facetError: {
                required: true
            },
            facetLoader: {
                required: true
            },
            omitCount: {
                required: false,
                default: false
            }
        },
        data: function () {
            return {
                fixedPosition: false,
                index: 0,
                facetCriteriaOrg: {},
                facetErrorMsg: 'An error has occurred. Please try again after sometime.',
                fieldCount: 0,
                lookupCount: 0,
                loadingLookupData: false,
                filters: false
            }
        },
        computed: {
            ...mapGetters([
                'searchType',
                'searchMeta'
            ]),
            facetData: function () {
                if (this.rawFacetData && !this.loadingLookupData) {
                    return this.parseFacetData(this.rawFacetData);
                } else {
                    return null;
                }
            },
            breakpoints: () => breakpoints.screen
        },
        mounted () {
            this.getLookupData();
            this.filters = app.$options.$filters;

            document.addEventListener('scroll', () => {
                this.setSidebarHeight();
            });

            setTimeout(() => {
                this.setSidebarHeight();
                this.updateURL();
            }, 1);
        },
        methods: {
            ...mapActions([
                'setLookup'
            //    'setSearchFacetCriteria',
            //    'setSearchFacetData',
            //    'setPublicationsFacetData',
            //    'setPublicationsFacetCriteria',
            //    'setMatchmakerFacetData',
            //    'setMatchmakerFacetCriteria',
            //    'updateSearchResultsFacets'
            ]),
            getLookupData () {
                var fieldSpecs = window.searchFieldSpecs,
                    specsLength = Object.keys(fieldSpecs).length,
                    specsCount = 0,
                    url,
                    field;

                this.loadingLookupData = true;

                for (let inputField in fieldSpecs) {
                    field = fieldSpecs[inputField];
                    specsCount++;
                    if (!this.$store.state.lookup[field.id] && ((field.control === 'MultiSelect' && !field.dynamicLookup) || field.control === 'InputRange')) {
                        url = '/services/Lookup/' + window.snakeToCamel(field.id);
                        this.fieldCount++;
                        this.callLookupService(url, field.id);
                    }

                    if (specsCount === specsLength) {
                        if (this.fieldCount === 0) {
                            this.loadingLookupData = false;
                        }
                    };
                }
            },
            updateURL () {
                var facetToQueryStr = this.generateQueryString();
                    // facets = this.facetData.facets;
                    if (this.$route.query.sort_field) {
                        facetToQueryStr['sort_field'] = this.$route.query.sort_field;
                    }
                    if (this.$route.query.sort_order) {
                        facetToQueryStr['sort_order'] =  this.$route.query.sort_order;
                    }

                if (facetToQueryStr) {
                    // facetToQueryStr['searchMode'] = this.searchType;
                    delete facetToQueryStr['shared'];
                    this.$router.push ({ query: facetToQueryStr }).catch(err => {});
                }
            },
            updateSearch (facet, timeout) {
                var facetToQueryStr = '';

                if (!timeout) {
                    timeout = 500;
                }

                this.facetError = false;
				
				gtag('event', 'Click', {
					'event_category':  'Search Results Facets',
					'event_label': 'Check/uncheck facet - ' + (facet ? facet.display : 'Is Active Project'),
					'value': 'Check/uncheck facet - ' + (facet ? facet.display : 'Is Active Project')
				});	

                // window.scrollTo(0, 0);
                if (this.$parent.scrollToResultsTop) {
                    this.$parent.scrollToResultsTop();
                }

                this.updateSearchResultsFacets(this.facetCriteria);

                if (this.updateProjectSearchResultsTimeout) {
                    clearTimeout(this.updateProjectSearchResultsTimeout);
                }

                this.updateProjectSearchResultsTimeout = setTimeout(() => {
                    this.$parent.clearSearchResults({resetFacets: false});
                    this.updateURL();
                    switch (this.$route.name) {
                        case 'list':
                            this.$parent.projectListTable.offset = 0;
                            this.$parent.getProjectSearchResults(false);
                            this.getFacets(false);
                            break;
                        case 'charts':
                            this.$parent.getProjectSearchGraphData(false);
                            this.getFacets(false);
                            break;
                        case 'map':
                            // this.$parent.getProjectSearchGraphData(false);
                            this.$parent.$refs.googleMap.updateMap();
                            this.$parent.$refs.googleMap.getTableData();
                            this.getFacets(false);
                            break;
                        case 'publications':
                            this.$parent.publicationTable.offset = 0;
                            this.$parent.getPublicationResults(false);
                            if (facet.name !== 'publication_years') {
                                this.getFacets(false);
                            }
                            break;
                        case 'patents':
                            this.$parent.patentTable.offset = 0;
                            this.$parent.getPatents(false);
                            this.getFacets(false);
                            break;
                        case 'clinicalStudies':
                            this.$parent.clinicalStudyTable.offset = 0;
                            this.$parent.getClinicalStudies(false);
                            this.getFacets(false);
                            break;
                        default:
                    }
                }, timeout);
            },
            callLookupService (url, thisId, serverlessAttempt) {
                var xhr = new XMLHttpRequest();

                xhr.open('GET', url, true);
                xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let data = JSON.parse(xhr.response);

                        if (this.id === '' || thisId === 'award_amount_range') {
                            this.setLookup({
                                field: thisId,
                                data: copyData(data)
                            });
                        } else {
                            if (data.length !== 0 && data[0].display !== undefined && data[0].value !== undefined) {
                                this.setLookup({
                                    field: thisId,
                                    data: copyData(data)
                                });
                                // if (this.$parent.$parent.buildCriteria) {
                                //     this.$parent.$parent.buildCriteria();
                                // }
                            }
                        }

                        this.lookupCount++;

                        if (this.lookupCount === this.fieldCount) {
                            this.loadingLookupData = false;
                        }
                    } else {
                        if (!serverlessAttempt) {
                            url = '/data/lookup-' + window.snakeToCamel(thisId) + '.json';
                            this.callLookupService(url, thisId, true);
                        }
                    }
                };
                xhr.onerror = () => {};
                xhr.send();
            },
            parseFacetData (data) {
                // cache variables for faster performance
                let dataLength = data.facets.length,
                    valuesLength,
                    lookupData,
                    i,
                    i2;

                for (i = 0; i < dataLength; i++) {
                    switch (data.facets[i].name) {
                        case 'fiscal_years':
                            // sort Fiscal Years descending by Year
                            data.facets[i].values.sort((a, b) => {
                                return b.value - a.value;
                            });

                            break;
                        case 'agencies':
                            // set up heirarchy from lookup data
                            if (this.$store.state.lookup.agencies) {
                                valuesLength = data.facets[i].values.length;

                                for (i2 = 0; i2 < valuesLength; i2++) {

                                    lookupData = this.$store.state.lookup.agencies.filter((item) => {
                                        return item.value === data.facets[i].values[i2].value;
                                    });

                                    if (lookupData.length !== 0) {
                                        data.facets[i].values[i2].parent_value = lookupData[0].parent_value;
                                        data.facets[i].values[i2].children_values = lookupData[0].children_values;
                                    }
                                }

                                // sort agencies facet alphabetically
                                data.facets[i].values.sort((a, b) => {
                                    let textA = a.display.toLowerCase(),
                                        textB = b.display.toLowerCase();

                                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                                });
                            }

                            break;

                        default:
                            // sort activity code facets alphabetically
                                data.facets[i].values.sort((a, b) => {
                                    let textA = a.display.toLowerCase(),
                                        textB = b.display.toLowerCase();

                                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                                });
                            break;
                    }
                }

                return data;
            },
            setSidebarHeight () {
                var resultArea = document.getElementsByClassName('searchResults'),
                    resultAreaOffset = resultArea && resultArea.length > 0 ? resultArea[0].offsetTop + 5 : 0,
                    scrollOffsetTop = this.$refs.facetsScroll ? this.$refs.facetsScroll.offsetTop : 0,
                    ResultsContainerOffsetTop = this.$parent.$parent.getResultsContainerOffsetTop(),
                    offset = 0;

                if (window.pageYOffset < ResultsContainerOffsetTop) {
                    offset = ResultsContainerOffsetTop - window.pageYOffset;
                }

                offset += scrollOffsetTop;

                this.$parent.$parent.getResultsContainerOffsetTop();

                if (this.$refs && this.$refs.sidebar) {
                    // if (this.$refs.sidebar.classList.contains('fixed-head')) {
                    if (this.$refs.facetsScroll && this.$refs.facetsScroll.style) {
                        // this.$refs.facetsScroll.style.height = 'calc(100vh - ' + this.$refs.facetsScroll.offsetTop + 'px)';
                        this.$refs.facetsScroll.style.height = 'calc(100vh - ' + offset + 'px)';
                    }
                    // } else {
                    //     if (this.$refs.facetsScroll) {
                    // //         this.$refs.facetsScroll.style.height = 'calc(100vh - ' + (this.$refs.facetsScroll.offsetTop - window.scrollY) + 'px)';
                    //         this.$refs.facetsScroll.style.height = 'auto';
                    //         this.$refs.facetsScroll.style.maxHeight = '100%';
                    //         // if (document.body.clientHeight < window.innerHeight) {
                    //         //     this.$refs.facetsScroll.style.maxHeight = (window.innerHeight - resultAreaOffset - this.$refs.facetsScroll.offsetTop) + 'px';
                    //         // }
                    //     }
                    // }
                }
            },
            returnFirstLevelFacets (data) {
                let filteredData = data.filter((item) => {
                        return !item.parent_value;
                    });

                return filteredData;
            },
            returnSecondLevelFacets (data, parentValue) {
                return data.filter((item) => {
                    return item.parent_value === parentValue;
                });
            },
            isIndeterminate (facet, value) {
                let secondLevel = this.returnSecondLevelFacets(facet.values, value.value),
                    checkedTotal = 0;

                for (let i = 0; i < secondLevel.length; i++) {
                    if (this.facetCriteria[facet.name].indexOf(secondLevel[i].value) !== -1) {
                        checkedTotal++;
                    }
                }

                if (checkedTotal > 0 && checkedTotal !== secondLevel.length) {
                    return true;
                }

                return false;
            },
            changeSearchCriteria () {
                var $this = this;
                setTimeout(function () {
                    $this.$emit('reinit-search');
					
					gtag('event', 'Click', {
						'event_category': 'Search Results Facets',
						'event_label': 'Check/uncheck facet - Is Active Project',
						'value': 'Check/uncheck facet - Is Active Project'
					});	
                }, 101);
            },
            checkCheck (facet, value) {
                let isChecked = false;

                setTimeout(() => {
                    if (facet) {
                        if (this.facetCriteria[facet.name].indexOf(value.value) !== -1) {
                            isChecked = true;
                        }

                        if (value.parent_value) {
                            let allChildrenOfParent = this.returnSecondLevelFacets(facet.values, value.parent_value),
                                allChecked = true,
                                checkedTotal = 0;

                            for (let i = 0; i < allChildrenOfParent.length; i++) {
                                // check if all siblings are checked
                                if (this.facetCriteria[facet.name].indexOf(allChildrenOfParent[i].value) === -1) {
                                    allChecked = false;
                                } else {
                                    checkedTotal++;
                                }
                            }

                            if (allChecked) {
                                if (this.facetCriteria[facet.name].indexOf(value.parent_value) === -1) {
                                    this.facetCriteria[facet.name].push(value.parent_value);
                                    if (!this.facetCriteriaOrg[facet.name]) {
                                        this.facetCriteriaOrg[facet.name] = [];
                                    }
                                    this.facetCriteriaOrg[facet.name].push(value);
                                }
                            } else if (this.facetCriteria[facet.name].indexOf(value.parent_value) !== -1) {
                                this.facetCriteria[facet.name].splice(this.facetCriteria[facet.name].indexOf(value.parent_value), 1);
                                if (this.facetCriteriaOrg[facet.name]) {
                                    this.facetCriteriaOrg[facet.name].splice(this.facetCriteria[facet.name].indexOf(value.parent_value), 1);
                                }
                                // indeterminent state
                                if (checkedTotal > 0) {

                                }
                            }
                        }

                        if (value.children_values && value.children_values.length !== 0) {
                            let allChildren = this.returnSecondLevelFacets(facet.values, value.value);

                            for (let i = 0; i < allChildren.length; i++) {
                                if (isChecked) {
                                    if (this.facetCriteria[facet.name].indexOf(allChildren[i].value) === -1) {
                                        this.facetCriteria[facet.name].push(allChildren[i].value);
                                        if (!this.facetCriteriaOrg[facet.name]) {
                                            this.facetCriteriaOrg[facet.name] = [];
                                        }
                                        this.facetCriteriaOrg[facet.name].push(allChildren[i]);
                                    }
                                } else {
                                    this.facetCriteria[facet.name].splice(this.facetCriteria[facet.name].indexOf(allChildren[i].value), 1);
                                    if (this.facetCriteriaOrg[facet.name]) {
                                        this.facetCriteriaOrg[facet.name].splice(this.facetCriteria[facet.name].indexOf(allChildren[i].value), 1);
                                    }
                                }
                            }

                        }

                        if (!value.children_values && !value.parent_value) {
                            if (isChecked) {
                                if (!this.facetCriteriaOrg[facet.name]) {
                                    this.facetCriteriaOrg[facet.name] = [];
                                }
                                this.facetCriteriaOrg[facet.name].push(value);
                            } else {
                                if (this.facetCriteriaOrg[facet.name]) {
                                    this.facetCriteriaOrg[facet.name].splice(this.facetCriteria[facet.name].indexOf(value.value), 1);
                                }
                            }
                        }
                    }
                    this.updateSearch(facet);
                }, 1);
            },
            generateQueryString () {
                var data = copyData(this.facetCriteria),
                    // queryStr = '',
                    queryStrParam = {};

                for (let field in data) {
                    switch (field) {
                        case 'fiscal_years':
                            if (data[field].length > 0) {
                                // queryStr += '$fy;' + data[field].join(';');
                                queryStrParam['fy'] = data[field].join(';');
                            }
                            break;
                        case 'org_names':
                            if (data[field].length > 0) {
                                // queryStr += '$org;' + data[field].join(';');
                                queryStrParam['org'] = data[field].join(';');
                            }
                            break;
                        case 'principal_investigators':
                            if (data[field].length > 0) {
                                // queryStr += '$PI;' + data[field].join(';');
                                queryStrParam['PI'] = encodeURI(data[field].join(';'));
                            }
                            break;
                        case 'is_active_projects':
                            if (data[field]) {
                                // queryStr += '$projects;Active';
                                queryStrParam['projects'] = 'Active';
                            }
                            break;
                        default:
                            if (data[field].length > 0) {
                                // queryStr += '$' + field + ';' + data[field].join(';');
                                queryStrParam[field] = data[field].join(';');
                            }
                    }
                }
                return queryStrParam;
            },
            updateSearch (facet, timeout) {
                this.updateURL();
                this.$emit('update-search', this.facetCriteria);
				
				gtag('event', 'Click', {
				   	'event_category': 'Search Results Facets',
					'event_label': 'Check/uncheck facet - ' + (facet ? facet.display : 'Is Active Project'),
					'value': 'Check/uncheck facet - ' + (facet ? facet.display : 'Is Active Project')
				});	
            },
            clearSelections (facetName, $e1) {
                $e1.cancelBubble = true;
				gtag('event', 'Click', {
				   	'event_category': 'Search Results Facets',
					'event_label': 'Clear facet - ' + facetName,
					'value': 'Clear facet - ' + facetName
				});	

                if ($e1.stopPropagation) {
                    $e1.stopPropagation();
                }

                this.facetCriteria[facetName] = [];
                this.facetCriteriaOrg[facetName] = [];

                this.updateURL();

                this.$emit('clear-selections', this.facetCriteria);
            },
            changeView (page) {
                var facetToQueryStr = this.generateQueryString();

                // let newRoute = '/search/' + this.$route.params.search_id + '/projects/' + (page ? page : '');
                if (page) {
                    page = '/' + page;
                }

                let newRoute = '/search/' + this.$route.params.search_id + '/projects' + (page ? page : '');// + '?searchMode=' + this.searchType;

                // this.$router.push(newRoute);
                this.$router.push({ path: newRoute, query: facetToQueryStr });

                // window.scrollTo(0, 0);
                this.$parent.$parent.scrollToResultsTop();

                if (!page && !this.searchResults) {
                    this.$parent.$parent.projectListTable.offset = 0;
                    this.$parent.$parent.getProjectSearchResults(false);
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '@/scss/variables.scss';
    .sidebar {
    .no-facet-data {
        padding: 6px 5px 6px 30px;
        line-height: 1em;
        font-size: 14px;
    }
    .nav-item {
        display: inline-block;
        width: 33.333%;
        padding: 0 5px;
        &.disabled {
            cursor: not-allowed;
            opacity: 0.6;
        }
    }
    .nav-link {
        position: relative;
        display: inline-block;
        padding: 2px 0 0 0;
        width: 100%;
        text-align: center;
        color: #333;
        font-weight: 500;
        font-size: 16px;
        border-radius: 6px;
        border: none;
        transition: 0.3s;
        overflow: hidden;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 35%;
            width: 30%;
            height: 3px;
            background-color: $blue;
            transition: 0.3s;
        }

        &.nav-link-list {
            &,
            .link-text {
                &:after {
                    background-color: $yellow;
                }
            }
        }

        &.nav-link-charts {
            &,
            .link-text {
                &:after {
                    background-color: $blue-charts;
                }
            }
        }

        &.nav-link-map {
            &,
            .link-text {
                &:after {
                    background-color: $teal;
                }
            }
        }

        &.disabled {
            cursor: not-allowed;
        }

        &:hover,
        &:focus,
        &.active {
            background-color: #fff;
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
            color: $blue;

            &:after {
                left: 0;
                width: 100%;
            }

            .nav-icon {
                fill: $blue;
            }
        }
    }

    .nav-icon {
        $icon-size: 34px;

        display: block;
        margin: 0 auto;

        width: $icon-size;
        height: $icon-size;

        fill: #555;

        transition: 0.3s;
    }

    .nav-icon-filter {
        $icon-size: 18px;

        display: inline-block;
        margin: 0 4px 0 0;

        width: $icon-size;
        height: $icon-size;

        fill: #5778a1;

        vertical-align: middle;
    }

    .back-btn {
        border-radius: 35px;
        border: none;
        padding: 3px 15px;
        background-color: #fff;
        color: $grey-med;
        margin: 10px auto;
        font-size: 15px;
        display: block;
        font-weight: bold;
        outline: none;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        cursor: pointer;
        &:hover,
        &:focus {
            box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.35);
        }
        svg {
            width: 16px;
            fill: $grey-med;
        }

        @media screen and (max-width: 1300px) {
            font-size: 13px;
        }
    }

    .link-text {
        position: relative;
        width: auto;
        padding-bottom: 3px;
        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: $yellow;
        }
    }

    #facets {
        .is-active {
            &.custom-control {
                label {
                    padding: 6px 5px 6px 35px;
                    font-size: 15px;
                    color: #20558a;
                    font-weight: bold;
                    span {
                        font-weight: bold;
                    }
                    &:after, &:before {
                        left: 8px;
                    }
                }
            }
        }
        h2 {
            margin: 8px 0 0 10px;
            color: #6b6b6b;
            @media screen and (max-width: 1300px) {
                margin: 8px 10px 0 10px;
                font-size: 18px;
            }
        }
        .fh-small {
            display: none;
        }

        .collapse,
        .collapsing {
            .collapse,
            .collapsing {
                ul {
                    ul {
                        padding-left: 20px;
                    }
                }
            }
        }

        ul {
            padding: 0;
            list-style: none;
            margin: 0;
        }

        li,
        button {
            width: 100%;
        }

        button {
            text-align: left;
            border: none;
            outline: none;

            &.collapsed {
                padding: .5em 5px .5em 10px;
                text-decoration: none;
            }
            &:hover, &:focus {
                text-decoration: none;
                background-color: #c6dcef;
                color: $blue-nih;
                outline: none;
                box-shadow: none;
            }
            &.not-collapsed {
                background-color: #e4e4e4;
                text-decoration: none;
            }
            i {
                color: $facets-arrow-color;
            }

            &.fac-clear {
                background-color: #fff;
                color: $red;
                font-size: 12px;
                font-weight: 700;
                margin: 0 2px 0 0;
                vertical-align: middle;
                padding: 1px 15px;
                text-transform: uppercase;
                position: relative;
                z-index: 200;
                // display: inline-block;
                min-width: 10px;
                white-space: nowrap;
                cursor: pointer;
                background-image: none;
                border: 1px solid transparent;
                border-radius: 12px;
                text-align: center;
                width: auto;
                float: right;

                &:hover,
                &:focus {
                    background-color: $red;
                    color: #fff;
                }
            }
        }

        .collapse.show {
            background-color: #e4e4e4;
            li {
                &:hover {
                    label {
                        &:before{
                            background-color: $blue-lighter;
                            border-color: $blue-light;
                        }
                    }
                }
            }
        }

        .custom-checkbox {
            .collapse-facet {
                display: inline-block;
                position: relative;
                top: -0.15em;
                width: auto;
                height: 1.25em;
                // margin-bottom: -0.5em;

                &:hover,
                &:focus {
                    background-color: transparent;
                }
            }
        }
    }

    .facets-scroll {
        overflow: auto;
        display: block;
        // TODO: make dynamic in future
        max-height: calc(100vh - 115px);
    }

    .collapse-button {
        position: relative;
        background: none;
        font-weight: 500;

        &:hover,
        &:focus {
            background-color: #c6dcef;
        }

        &[aria-expanded="true"] {
            > .collapse-icon {
                transform: rotate(90deg);
            }
        }
    }

    .btn-link, a {
        font-weight: bold;
        &.collapsed {
            svg, i {
                transform: rotate(-90deg);
            }
        }
    }

    .collapse-category {
        padding: 1em 5px 1em 30px;
        font-size: 15px;
        font-weight: 500;
        color: #333;
        line-height: 1.25em;
        // background-color: #dedede;

        .collapse-facet {
            padding: 0.5em 5px 0.5em 50px;
            font-size: 14px;

            .collapse-icon {
                left: 30px;
            }
        }
    }

    .collapse-facet {
        padding: 0.5em 5px 0.5em 30px;
        font-size: 15px;
        font-weight: bold;
        // color: #333;
        color: $blue;

        &,
        + .collapse,
        + .collapsing {
            transition: 0.3s;

            li:last-child {
                padding-bottom: 8px;
            }
        }

        &.collapsed {
            &,
            + .collapse,
            + .collapsing {
                background-color: transparent;
            }

            &:hover,
            &:focus {
                background-color: #c6dcef;
            }
        }

        .collapse-icon {
            left: 10px;
        }
    }

    .collapse-icon {
        position: absolute;
        top: calc(50% - 0.5em);
        left: 10px;
        width: 15px;
        height: 15px;
        fill: $facets-arrow-color;
        transition: 0.3s;
    }

    .custom-control {
        display: block;
        position: relative;
        width: 100%;
        padding-left: 0;

        label {
            display: block;
            $line-height: 1em;

            padding: 6px 5px 6px 55px;
            line-height: #{$line-height};
            width: 100%;

            &:before,
            &:after {
                // top: calc(50% - 0.725rem);
                top: calc(#{$line-height} / 2 - 0.725rem + 7px);
                left: 28px;
                // font-size: 12px;
                // width: 1.45em;
                // height: 1.45em;
            }
        }
    }

    .form-check-inline {
        margin: 0;
        // padding: 4px 0;
    }

    .label-text {
        font-size: 14px;
        font-weight: 400;
    }

    .label-count {
        margin-left: 0.4em;
        color: #616161;
        font-size: 12px;
        font-weight: 500;
    }

    .error-message {
        display: block;
        color: #cc4545;
        font-weight: 500;
        border-radius: 4px;
        margin: 15px;
    }

    @media screen and (max-width: $screen-md-min) {
        #facets {
            .collapse:not(.show) {
                display: none;
            }
            .fh-small {
                display: block;
                margin-bottom: 10px;
                a {
                    background-color: #fff;
                    padding: 5px 12px;
                    display: inline-block;
                    border-radius: 3px;
                    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
                    &:hover,
                    &:focus {
                        text-decoration: none;
                        background-color: $blue-light;
                        color: #fff;
                        .nav-icon-filter {
                            fill: #fff;
                        }
                    }
                }
            }

            .fh-full {
                display: none;
            }
        }
    }
    }
</style>
